require('./index.css')
require('./turntable')

let dialog = require('@components/dialog')
let request = require('@common/request')
let utils = require('@common/utils')
let iBorad = require('@common/iBorad')
let mask = require('../mask/index')
let animationCount = 0
try {
  var tguid = qbsdk.getServerGuid();//window.external.getFavSyncGuid();
} catch (e) {

}


function Lottery() {
  var _$ = $
  var _that = this
  this.hasMoney = true
  this.inGame = false
  this.showNotShare = false
  this._pageUrl = location.protocol + '//' + location.host + location.pathname;
  //中奖记录滚动展示
  this.queryLotteryNamelist = function () {
    var amsConfig = zMsg.getFormData(1); //获取数据
    var rules = [];
    rules.push('<ul id="namelist">');
    for (var i in amsConfig) {
      rules.push('<li>' + amsConfig[i]['f_1'] + '&nbsp;&nbsp;&nbsp;' + amsConfig[i]['f_2'] + '</li>')
    }
    rules.push('</ul>')
    $('#namelistDiv').html(rules.join(''))
    //获奖名单
    var luckBorad = new iBorad('#luckBoard');
    var boxHtml = '';
    /* luckBoard Load */
    //获奖名单
    var list = amsConfig;
    if (amsConfig) {
      for (var k in amsConfig) {
        boxHtml += '<div class="box">' + amsConfig[k].f_1 + '&nbsp;' + amsConfig[k].f_2 + '&nbsp;;</div>';
      }
      $(boxHtml).appendTo('#luckBoard .board-slide')
        .first().addClass('box-active');
      luckBorad.init();
    } else {
      boxHtml += '<div class="box">&nbsp;&nbsp;暂无获奖名单</div>';
      $(boxHtml).first().addClass('box-active')
        .appendTo('#luckBoard .board-slide')
    }

  };
  //分享
  this.shareTo = function (type) {
    var _that = this
    _qblog.wsd.click("GREATEXPECTATIONS.SHARE")
    request.send({
      'actid': 272583, //分享增加抽奖机会
    }, function (res) {
      if (res.ret === 0) {
        //分享成功
        _that.setMoney('++');
        _qblog.wsd.click("GREATEXPECTATIONS.SHARESUCCESS")
      }
    });
    var shareObj = {
      qzone: function (a) {
        var b = {
          url: a.url,
          showcount: "1",
          desc: a.description || "",
          summary: a.summary || "",
          title: a.title,
          pics: a.pic || null,
          style: "203",
          width: 98,
          height: 22
        };
        var s = [];
        for (var i in b) {
          s.push(i + '=' + encodeURIComponent(b[i] || ''));
        }
        return "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?" + s.join('&');
      },
      sina: function (a) {
        var b = {
          title: a.description,
          frefer: a.url,
          url: a.url,
          pic: a.pic || null
        };
        var s = [];
        for (var i in b) {
          s.push(i + '=' + encodeURIComponent(b[i] || ''));
        }
        return "http://service.weibo.com/share/share.php?uid=1&" + s.join('&');
      },
      qq: function (a) {
        return "http://connect.qq.com/widget/shareqq/index.html?url=" + encodeURIComponent(a.url) +
          "&desc=" + encodeURIComponent(a.description) +
          "&pics=" + encodeURIComponent(a.pic) +
          "&summary=" + encodeURIComponent(a.description) +
          "&title=" + encodeURIComponent(a.title) +
          "&flash=&site=QB&style=100&width=98&height=22";
      }
    };
    var wording = {
      "sina": {
        url: this._pageUrl + '?fr=sina',
        pic: "http://stdl.qq.com/stdl/qb/kp/greatexpectations.jpg",
        title: "追剧有特权 一起抽好礼",
        description: "最近追《远大前程》，演员们全部演技在线！QQ浏览器还送追剧福利：有腾讯视频VIP、年度限量周边、签名照可以免费抽~"
      },
      "qq": {
        url: this._pageUrl + '?fr=qq',
        pic: "http://stdl.qq.com/stdl/qb/kp/greatexpectations.jpg",
        title: "追剧有特权 一起抽好礼",
        description: "最近追《远大前程》，演员们全部演技在线！QQ浏览器还送追剧福利：有腾讯视频VIP、年度限量周边、签名照可以免费抽~"
      },
      "qzone": {
        url: this._pageUrl + '?fr=qzone',
        pic: "http://stdl.qq.com/stdl/qb/kp/greatexpectations.jpg",
        title: "追剧有特权 一起抽好礼",
        description: "最近追《远大前程》，演员们全部演技在线！QQ浏览器还送追剧福利：有腾讯视频VIP、年度限量周边、签名照可以免费抽~",
        summary: "最近追《远大前程》，演员们全部演技在线！QQ浏览器还送追剧福利：有腾讯视频VIP、年度限量周边、签名照可以免费抽~"
      }
    };
    if (qq.login.getUin()) {
      window.open(shareObj[type](wording[type]));
    }
  };
  // 抽奖
  this.getLucky = function () {
    var _that = this
    _qblog.wsd.click("GREATEXPECTATIONS.LUCKY")
    request.send({
      'actid': 272599
    }, function (res) {
      if (res.ret === 0) {
        if (res.data.op.count >= 1) {
          if (_that.inGame) {
            return;
          }
          request.send({
            // 抽奖id
            'actid': 272582,
          }, function (res) {
            // var res = {
            //   data: {
            //     join: {
            //       level: 4
            //     },
            //     op: {
            //       cdkey: '111111111111111111',
            //       diamonds: 3,
            //       name: '一年假期',
            //       count: 0
            //     }
            //   },
            //   ret: 0
            // }
            if (res.ret === 0) { //展示奖品
              _that.setMoney('--', true);
              _qblog.wsd.click("GREATEXPECTATIONS.LUCKY.OK")
              var key = res.data.op.diamonds;
              var title = res.data.op.name;
              var str = '';
              str += '<div class="tit">恭喜获得 ' + title + '</div>';
              //四等奖月卡添加cdkey
              str += '<div class="gift lv' + key + '"></div>';
              // console.log(key,"=======",res.data,"----------",title)
              switch (key) {
                case 1:
                case 2:
                  str += '<div class="btn close"><a href="#" onclick="lottery.getUserContact()">填写联系方式</a>';
                  break;
                case 3:
                case 4:
                  str += '<div class="cdkey">腾讯视频兑换码:' + res.data.op.cdkey + '</div>';
                  str += '<div class="btn"><a href="http://film.qq.com/duihuan.html" class="userCon" target="_blank">立即兑换</a>';
                  break
                case 5:
                  str += '<div class="btn"><a href="#" class="close">我知道了</a>';
                  break;
                default:
                  str += '<div class="btn"><a href="#" class="close">我知道了</a> ';
              }
              str += '</div><div class="rule"><p>奖品发放规则：</p>';
              str += '<p>● Q币会在活动结束后一个月内，统一充值到参与活动的QQ号</p>';
              str += '<p>● 视频会员、优惠券、现金券等虚拟奖品中奖后，需立即前往指定产品官方页面进行兑换</p>';
              str += '<p>● 实物奖品将在活动结束后一月内统一发货，请在中奖后立即填写有效联系方式，因用户提供的联系地址不详以致奖品回寄的情况，将不予补送；奖品图片仅供参考，一切以实物为准</p>';
              str += '</div>';
              if (res.data.join && res.data.join.level == 1) { //第二次抽完奖ke提示分享
                _that.showNotShare = true;
                request.send({
                  // 查询今天是否分享过
                  'actid': 272597,
                }, function (res) {
                  if (res.ret === 0) { //分享过
                    if (res.data.op.count >= 1) {
                      _that.showNotShare = false;
                    } else {
                      _that.showNotShare = true;
                    }
                  }
                });
                luckAnimation.StartGame(key, function () {
                  _that.setMoneyStatus();
                  if (key < 6) {
                    mask('showPrize')
                    $('.dialog-show-prize .gifts').html(str);
                  } else {
                    if (_that.showNotShare) {
                      mask('shareGetChance');
                      _that.showNotShare = false;
                    }
                  }
                });
              } else {
                _that.showNotShare = false;
                luckAnimation.StartGame(key, function () {
                  _that.setMoneyStatus();
                  if (key < 6) {
                    setTimeout(function () {
                      mask('showPrize')
                      $('.dialog-show-prize .gifts').html(str);
                    }, 1000)
                  }
                });
              }
            } else if (res.ret === 20801) { //没有机会啦
              // 查询今天是否分享过
              request.send({
                'actid': 272597,
              }, function (res) {
                if (res.ret === 0) { //分享过
                  if (res.data.op.count >= 1) {
                    mask('activtyEnd', '今日抽奖机会已到上限啦，明天再分享依然', '可获得额外机会！')
                  } else {
                    mask('shareGetChance');
                  }
                }
                _that.inGame = false;
              });
            } else if (res.ret === 10002) {
              qq.login.open();
              _that.inGame = false;

            } else if (res.ret == 10001 || res.ret == 10004) {
              mask('activtyEnd', '活动已经结束，敬请期待更多QQ浏览器特权活动！', '')
              _that.inGame = false;
            }
          });
        } else {
          mask("notSub")
        }
      }
    })

  };
  //获取订阅信息
  this.getVideoInfo = function (t) {
    //有参数t 为抽奖前判断，无则为进入页面判断~~
    // 请求接口http: //video.browser.qq.com/api/get_video_info?video_id=100323888
    //判断是否订阅国语版
    $.ajax({
      url: "http://video.browser.qq.com/api/get_video_info",
      type: 'get',
      data: {
        video_id: 100325781,
        tguid: tguid
      },
      success: function (res) {
        //假数据
        // var res = {
        //   subscribe: "已订阅"
        // }
        if (res.subscribe) { //已订阅
          $('.mod-lottery .dy').addClass('yi').html('<a href="javascript:void(0)"></a>');
          _that.sub();
        } else { //未订阅
          $('.mod-lottery .dy').removeClass('yi').html('<a href="javascript:void(0)" onclick="lottery.sub(true)">');
        }
      }
    });
  };
  //订阅  ams
  this.sub = function (t) { //有t 才同步到追剧助手
    var _that = this
    request.send({
      // 订阅增加抽奖机会
      'actid': 272585,
    }, function (res) {
      if (t) {
        _that.subscribeToVideobox(100325781);
      }
      if (res.ret === 0) { //第一次参加订阅
        _qblog.wsd.click("GREATEXPECTATIONS.DINYUE.OK")
        _that.setMoney('++');
        _that.setMoney('++');
      }
    })

  };
  //同步到追剧助手
  this.subscribeToVideobox = function (vid) { // video.browser.qq.com/域下才可以
    _qblog.wsd.click("GREATEXPECTATIONS.DINYUE.CLICK")
    $('.mod-lottery .dy').addClass('yi').html('<a href="javascript:void(0)"></a>');
    var videobox_extension_id = 'fpbdfpimimonlkoapobdbldphmiplmml';

    function sendSubscribe() {
      _qblog.wsd.click("GREATEXPECTATIONS.DINYUE.CLICK")
      chrome.runtime.sendMessage(videobox_extension_id, {
        action: 'video_center_follow_pop',
        data: {
          'vid': vid,
          orgin: 'great_expectations_201804'
        }
      })
    }
    try {
      chrome.management.get(videobox_extension_id, function (res) {
        if (res) {
          if (res.enabled) {
            sendSubscribe();
          } else {
            chrome.management.setEnabled(videobox_extension_id, true, function () {
              sendSubscribe();
            });
          }

        } else {
          chrome.management.install({
            id: videobox_extension_id
          }, function (res) {
            window.setTimeout(sendSubscribe, 600)
          })
        }
      })
    } catch (e) {
      sendSubscribe()
    }
  };
  //查询中奖记录
  this.queryRecord = function () {
    if (this.inGame) return;
    request.send({
      // zeroj 查询获奖记录
      'actid': 272584
    }, function (res) {
      if (res.ret == 0) {
        var msg = res.data.op;
        // var msg = [{
        //   val: {
        //     level: 5,
        //     time: 1521966470,
        //     name: "Q币",
        //     info: "11111111111111"
        //   }
        // }]
        var str = ''
        if (msg.length !== 0) {
          str = '<li><span>中奖日期</span><span>奖品名称</span><span>奖品详情</span><span>操作</span></li>';
          for (var i = 0; i < msg.length; i++) {
            if (msg[i].val.level < 4) { //实物
              str += '<li><span>' + qv.date.format("Y.m.d", msg[i].val.time * 1000) + '</span><span>' + msg[i].val.name + '</span><span>实物奖品</span>';
              str += '<span><a href="javascript:;" class="userCon" onclick="lottery.getUserContact()">填写联系方式</a></span></li>';
            } else if (msg[i].val.level == 4) { // 月卡
              str += '<li><span>' + qv.date.format("Y.m.d", msg[i].val.time * 1000) + '</span><span>' + msg[i].val.name + '</span><span>兑换码：' + msg[i].val.info;
              str += ' <i id="qtips"> ？<span class="duiRule">';
              str += '<ul><li><p>活动规则：</p></li>\
                                              <li><p>● Q币会在活动结束后一个月内，统一充值到参与活动的QQ号</p></li>\
                                              <li><p>● 视频会员、优惠券、现金券等虚拟奖品中奖后，需立即前往指定产品官方页面进行兑换</p></li>\
                                              <li><p>● 实物奖品将在活动结束后一月内统一发货，请在中奖后立即填写有效联系方式，因用户提供的联系地址不详以致奖品回寄的情况，将不予补送；奖品图片仅供参考，一切以实物为准</p></li>\
                                          </ul>';
              str += '</span></i></span>';
              str += '<span><a href="http://film.qq.com/duihuan.html" class="userCon" target="_blank">去兑换</a></span></li>';
            } else if (msg[i].val.level == 5) { // qb
              str += '<li><span>' + qv.date.format("Y.m.d", msg[i].val.time * 1000) + '</span><span>' + msg[i].val.name + '</span>';
              str += '<span>虚拟奖品 <i id="qtips"> ？<span class="duiRule">';
              str += '<ul><li><p>活动规则：</p></li>\
                                              <li><p>● Q币会在活动结束后一个月内，统一充值到参与活动的QQ号</p></li>\
                                              <li><p>● 视频会员、优惠券、现金券等虚拟奖品中奖后，需立即前往指定产品官方页面进行兑换</p></li>\
                                              <li><p>● 实物奖品将在活动结束后一月内统一发货，请在中奖后立即填写有效联系方式，因用户提供的联系地址不详以致奖品回寄的情况，将不予补送；奖品图片仅供参考，一切以实物为准</p></li>\
                                          </ul>';
              str += '</span></i></span>';
              str += '<span>自动到账</span></li>';
            }
          }
        } else {
          str += '<div id="space">'
          str += '<img src="http://stdl.qq.com/stdl/qb/kp/space.png">'
          str += '<p>暂无获奖记录，快去参加活动吧</p>'
          str += '</div>'
        }

        mask('myGifts');
        $('.dialog-myGifts .giftRecord .gifts').html(str);
      } else if (res.ret == 10002) {
        qq.login.open();
      } else if (res.ret == 10001 || res.ret == 10004) {
        mask('activtyEnd', '活动已经结束，敬请期待更多QQ浏览器特权活动！', '')
      } else {
        zHttp.showResponse(res, res.actid, $.noop);
      }
    });
  };
  //查询抽奖次数
  this.queryTicket = function () {
    var _that = this

    // 查询抽奖次数
    request.send({
      'actid': 272598,
    }, function (res) {
      if (res.ret == 0) {
        var m = parseInt(res.data.op);
        if (m == 0) {
          $('.btn_lucky').addClass('zero')
        }
        _that.setMoney(m);
      }
    });
  };
  //设置抽奖次数
  this.setMoney = function (m, s) {
    var me = jQuery('#money');
    var meVal = parseInt(me.text());
    var k = 0;
    if (parseInt(m) < 0) {
      k = meVal + parseInt(m);
    } else if (m === '++') {
      k = meVal + 1;
    } else if (m === '--') {
      k = meVal - 1;
    } else if (!isNaN(m)) {
      if (m.toString().indexOf('-') >= 0 || m.toString().indexOf('+') >= 0) {
        k = meVal + parseInt(m);
      } else {
        k = m;
      }
    }
    if (k < 0) {
      k = 0;
    }
    if (+k > 0) {
      this.hasMoney = true;
    } else {
      this.hasMoney = false;
    }
    me.text(k);
    if (!s) {
      if (k == 0) {
        $('.btn_lucky').addClass('zero');
      } else {
        $('.btn_lucky').removeClass('zero');
      }
    } else {
      $('.btn_lucky').addClass('active');
    }
  };
  this.setMoneyStatus = function () {
    if ($('#money').text() == '0') {
      $('.btn_lucky').addClass('zero');
    } else {
      $('.btn_lucky').removeClass('zero');
    }
    $('.btn_lucky').removeClass('active');
  }
  this.setUserContact = function () {
    userAddress.submitUserInfo("userName", "phoneNum",
      "detailAddr",
      "zipCode",
      function () {
        _$(".dialog-user-contact #success-submit").fadeIn(500).fadeOut(500)
      });
  }
  this.getUserContact = function () {
    userAddress.getUserInfo(function (res) {
      $('#userCon .userInfo').html(userAddress.tempContact(res));
    });
    mask('userCon');
  };
}
window.lottery = new Lottery()



// WEBPACK FOOTER //
// ./modules/lottery/index.js